import React, {Suspense, useEffect, useState} from 'react';

import {useTranslation} from "react-i18next";

import LINKS from "../core/data/links/menu_links";
import SOCIAL_LINKS  from "../core/data/links/social_links";

import useAnalyticsEventTracker from '../core/g-analytics/useAnalyticsEventTracker';

import LanguageSwitch from "../components/basic/language";
import Zoom from "react-medium-image-zoom";
import QRCode from "react-qr-code";
import {
    FaBook, FaCheckCircle,
    FaFile,
    FaGlobe,
    FaMobile, FaUserCheck
} from "react-icons/fa";
import {Link} from "react-router-dom";

function LinksPage(props) {

    const data = [
        {
            label: {
                en: "Website",
                ua: "Веб-сайт"
            },
            url: "y-l.pro",
            img: "",
            icon: <FaGlobe />,
            username: "",
            size: ""
        },
        {
            label: {
                en: "CV",
                ua: "Резюме"
            },
            url: "cv.y-l.pro",
            img: "",
            icon: <FaUserCheck />,
            username: "",
            size: ""
        },
        {
            label: {
                en: "About me",
                ua: "Про мене"
            },
            url: "y-l.pro/about",
            img: "",
            icon: <FaUserCheck />,
            username: "",
            size: ""
        },
        {
            label: {
                en: "",
                ua: "Блог"
            },
            url: "lukyanchuk.com",
            img: "",
            icon: <FaFile />,
            username: "",
            size: ""
        },
        {
            label: {
                en: "",
                ua: "Книгі"
            },
            url: "books.lukyanchuk.com",
            img: "https://static.vecteezy.com/system/resources/previews/009/376/176/original/3d-black-book-illustration-png.png",
            icon: <FaBook />,
            username: "",
            size: ""
        },
        {
            label: {
                en: "",
                ua: "Мобільні застосунки"
            },
            url: "apps.lukyanchuk.com",
            img: "https://media.sketchfab.com/models/b3a6a573622b45cc9b11c9e1d34064f5/thumbnails/ae5ffaa2e43743c0a3476c35494b28a5/0c940ea11c8d4892908fd0424c4e0385.jpeg",
            icon: <FaMobile />,
            username: "",
            size: ""
        },
        // {
        //     label: {
        //         en: "",
        //         ua: "Сертифікати"
        //     },
        //     url: "https://y-l.pro/about/certificates",
        //     img: "",
        //     icon: <FaCertificate />,
        //     username: "",
        //     size: ""
        // },
        // {
        //     label: {
        //         en: "",
        //         ua: "Наукова робота"
        //     },
        //     url: "https://y-l.pro/about/science-work",
        //     img: "",
        //     icon: <FaGraduationCap />,
        //     username: "",
        //     size: ""
        // }
    ];

    const gaEventTracker = useAnalyticsEventTracker('LINKS');

    const {t, i18n} = useTranslation();

    var _langClass = 'fw-bold';

    const _setLanguage = (lang) => {
        i18n.changeLanguage(lang)
        if (lang === 'ua') {
            document.getElementById('langUA').classList.add(_langClass);
            document.getElementById('langEN').classList.remove(_langClass);
        } else {
            document.getElementById('langUA').classList.remove(_langClass);
            document.getElementById('langEN').classList.add(_langClass);
        }
    }

    const _ua = <small id={'langUA'} onClick={() => _setLanguage('ua')}>UA</small>
    const _en = <small id={'langEN'} onClick={() => _setLanguage('en')}>EN</small>

    const [isDarkMode, setDarkMode] = React.useState(false);

    const toggleDarkMode = (checked) => {
        setDarkMode(checked);
    };

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [isDarkMode]);

    return (
        <div id={'LinksPage'} className={''}>

            {/*<HeaderComponent />*/}
            <header className={'min-vw-100 fixed-top p-2 d-flex justify-content-end align-items-start'}>

                <div className="p-2" style={{width: "70px"}}>
                    <Zoom>
                        <QRCode
                            size={256}
                            style={{ height: "100%", maxWidth: "100%", width: "100%" }}
                            value={'https://apps.y-l.pro/app/yl-app'}
                            viewBox={`0 0 256 256`}
                            className={'border shadow'}
                        />
                    </Zoom>
                </div>
            </header>

            {/*{ !dayPart.includes('PM')*/}
            {/*    ? <img src="https://images.unsplash.com/photo-1542296030-4d54bac0fc3a"  alt="image" className={'img-fluid rounded-start hidden-block'}/>*/}
            {/*    : <img src="https://images.unsplash.com/photo-1498335746477-0c73d7353a07"  alt="image" className={'img-fluid rounded-start hidden-block'}/>*/}
            {/*}*/}

            <br/>

            <main className="container d-flex justify-content-center align-items-center" style={{height: '25vh'}}>

                <div className="col-md-6 m-auto">

                    <div className="d-flex justify-content-between">
                        <div>
                            <img src="https://avatars.githubusercontent.com/u/32492503?v=4" alt="avatar" className={'rounded-circle border shadow'} style={{width: "75px"}}/>

                            <h3 className={'mt-3'}>{t('my.name')} <FaCheckCircle color={'#1DA1F2'} size={21} /> </h3>
                            {/*<small className={'text-secondary'}>@yariklukyanchuk</small>*/}
                            <small className={'text-secondary'}>Software Developer</small>
                        </div>

                        <LanguageSwitch color={!props.isDarkMode ? 'white' : ''} />
                    </div>
                </div>

            </main>

            <div className="container">

                <div className="col-md-6 m-auto border rounded-5 shadow-lg p-2">
                    {
                        data.map((item, i) => <div key={i} className="border p-3 rounded-5 mt-2">

                            <div id={"link_item#"+i} className="d-flex justify-content-between align-items-center">
                                <div className="col-md-5 col-5">
                                    {item.icon}
                                    <br/>
                                    <small className={'text-secondary'}>{item.url}</small>
                                </div>

                                <div className="col-md-6 col-6">
                                    <Link to={item.url} className={'nav-link'} target={'_blank'}>
                                        <h6 className={''}>{item.label.ua}</h6>
                                    </Link>
                                </div>

                                <div className="col-md-1 col-1">
                                    <Zoom>
                                        <QRCode
                                            size={256}
                                            style={{ height: "100%", maxWidth: "100%", width: "100%" }}
                                            value={item.url}
                                            viewBox={`0 0 256 256`}
                                            className={'border border-2 rounded-end-4'}
                                        />
                                    </Zoom>
                                </div>
                            </div>

                        </div>)
                    }
                </div>
                <br/>
                <div className="col-md-6 m-auto">
                    <div className="d-flex flex-wrap p-2 mt-5 mb-5">
                        {
                            SOCIAL_LINKS.map(social_link => <div className="col-md-4">
                                <div className="border p-3 rounded-5 d-flex align-items-center m-1">
                                    {social_link.icon} <Link onClick={()=>gaEventTracker('social-link-' + social_link.title)} to={social_link.path} className={'nav-link'} target={'_blank'}> <span>{social_link.title}</span></Link>
                                </div>
                            </div>)
                        }
                    </div>

                </div>

            </div>

            <footer className="d-flex justify-content-center align-items-center">
                <p>
                    <small className="m-1">{t('nav.copyright')} © {new Date().getFullYear()}. {t('my.name')}.</small>
                </p>
                <p className={'text-secondary'}>
                    <small><Link to={'/info'} className={'nav-link m-1'}>Privacy policy</Link></small>
                </p>
            </footer>

        </div>
    );
}

export default LinksPage;
